import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function LightingPage() {
  const serviceData = {
    title: 'Lighting Solutions',
    subtitle: 'Illuminate Your Space',
    description: 'Transform your home or business with our professional lighting solutions. From energy-efficient LED installations to decorative feature lighting, we design and install lighting systems that enhance ambiance, improve functionality, and reduce energy costs.',
    heroImage: 'https://public.readdy.ai/ai/img_res/306b6ebf571f6912f76918c65c701ee7.jpg',
    features: [
      {
        icon: 'ri-lightbulb-line',
        title: 'LED Upgrades',
        description: 'Energy-efficient LED lighting installations'
      },
      {
        icon: 'ri-sun-line',
        title: 'Downlight Installation',
        description: 'Modern recessed lighting solutions'
      },
      {
        icon: 'ri-contrast-2-line',
        title: 'Dimmer Controls',
        description: 'Smart dimming systems for ambiance control'
      },
      {
        icon: 'ri-landscape-line',
        title: 'Outdoor Lighting',
        description: 'Garden and security lighting design'
      }
    ],
    benefits: [
      'LED downlight installation',
      'Feature lighting design',
      'Dimmer switch installation',
      'Outdoor and garden lighting',
      'Security lighting solutions',
      'Energy efficiency upgrades',
      'Smart lighting integration',
      'Lighting design consultation'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Design Consultation',
        description: 'Discuss your lighting goals and preferences'
      },
      {
        number: '02',
        title: 'Lighting Plan',
        description: 'Create a customized lighting design'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Professional fitting and wiring of all fixtures'
      },
      {
        number: '04',
        title: 'Final Adjustment',
        description: 'Fine-tune lighting levels and demonstrate controls'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}